import React from 'react';

import { UiKit } from 'components';
import { FeatureContainer } from '../../components';
import * as ReturnsModeConfig from './ReturnsModeConfig';
import { useFTUWizard } from '../../context';

export default function ReturnMode() {
  const { onGotoNext } = useFTUWizard();

  return (
    <FeatureContainer
      title="How do you want returns to work?"
      subtitle="Pick the returns experience you want your customers to have. You can change this later."
    >
      <ReturnsModeConfig.Provider>
        <UiKit.Sheet.ActionsPortal>
          <ReturnsModeConfig.SaveButton onDone={onGotoNext} />
        </UiKit.Sheet.ActionsPortal>
      </ReturnsModeConfig.Provider>
    </FeatureContainer>
  );
}
